module.exports = __webpack_public_path__ + "static/img/home3.09e95044.png";